import { Amplify } from 'aws-amplify';
import { Provider } from 'react-redux';
import config from './amplifyconfiguration.json';
import './App.css';
import './AuxClasses.css';
import MainComponent from './components/MainComponent/MainComponent';
import "./fonts.css";
import './index.css';
import "./normalize.css";
import DeviceRedirector from './redirect/DeviceRedirector';
import { store } from './redux/store/store';
import GetInitialData from './utils/GetInitialData/GetInitialData';
import NotificationComponent from './utils/notifications/NotificationComponent';
import SignInProvidersListener from './utils/SignInProvidersListener/SignInProvidersListener';

Amplify.configure(config);

function App() {

    if (window.location?.protocol !== 'https:') {
        //window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
    }

    return (
        <Provider store={store}>
            <DeviceRedirector />
            <NotificationComponent />
            <SignInProvidersListener />
            <GetInitialData />
            <div className='main-container'>
                <MainComponent />
            </div>
        </Provider>

    );
}

export default App;
